module.exports = __webpack_public_path__ + "static/media/loc1_img8.591ae46f.jpg";